import { BlochSphere } from "@/components/BlochSphere";
import "./index.css";

export function App() {
  return (
    <main className="relative z-10 mx-auto w-full space-y-4 p-2 md:w-[80vw] md:space-y-6 md:p-4">
      <header className="rounded-xl border border-border/70 bg-background/85 p-4 shadow-sm backdrop-blur">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div className="space-y-2">
            <h1 className="text-3xl font-semibold tracking-tight md:text-4xl">Quantum Bloch Sphere Demo</h1>
            <p className="max-w-3xl text-sm text-muted-foreground md:text-base">
              Interactive single-qubit visualization for lessons and demos. Apply gates, enter exact states, and inspect Bloch coordinates in real time.
            </p>
          </div>
          <div className="flex flex-wrap gap-2 text-xs text-muted-foreground">
            <span className="rounded-md border border-border/70 bg-muted/40 px-2 py-1">GPU WebGL</span>
            <span className="rounded-md border border-border/70 bg-muted/40 px-2 py-1">KaTeX Math</span>
            <span className="rounded-md border border-border/70 bg-muted/40 px-2 py-1">Strict Unitary Checks</span>
          </div>
        </div>
      </header>

      <section className="grid gap-6">
        <BlochSphere theme="auto" ambientPan showHistory interactionMode="orbit-and-state-drag" />
      </section>

      <footer className="rounded-xl border border-border/70 bg-background/75 px-4 py-3 text-xs text-muted-foreground backdrop-blur">
        Tip: Drag to orbit, drag the green tip to set state, and use the side panel for exact a|0&gt; + b|1&gt; inputs and custom gates.
      </footer>
    </main>
  );
}

export default App;
